import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CandidacyPlacement,
  CreateCandidacyPlacementRequest,
  HttpResponse,
} from "@/types";

export function useCreatePlacement() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      createPlacementRequest,
    }: {
      createPlacementRequest: CreateCandidacyPlacementRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/placements`;
      const res = await guacHttpClient.post<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>,
        CreateCandidacyPlacementRequest
      >(path, createPlacementRequest);

      return res.data;
    },
  });

  return mutation;
}
